define('PageNavigation/pageNavigation',[
],
    function () {

        const pageNavigationSelector = ".page-navigation";
        const navigationItemSelector = ".page-navigation .page-navigation-item";
        const pageNavSelectorMobile = ".page-navigation-mobile";
        const navItemSelectorMobile = ".page-navigation-mobile .page-navigation-item";

        //Check if element is in the viewport
        function isAnyPartOfElementInViewport(el) {
            const rect = el.getBoundingClientRect();
            const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
            const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);

            return (vertInView);
        }

        function deselectAllHrefs(itemsHref, activeCssClasses) {
            if (itemsHref) {
                for (var i = 0; i < itemsHref.length; i++) {
                    var activeElement = $(".page-navigation .page-navigation-item").has("a[href='" + itemsHref[i] + "']");
                    $(activeElement).removeClass(activeCssClasses);
                }
            }
        }

        function init() {

            //MOBILE PAGE NAVIGATION

            //Initialize all Mobile Page Navigations on the page
            $(pageNavSelectorMobile).each(function (i, element) {

                var pageNavItems = $(".page-navigation-mobile .page-navigation-item");
                var pageNavItemLinks = $(".page-navigation-mobile .page-navigation-item a[href^='#']");
                var itemsHref = [];
                

                //Extract ids from pageNavItems
                $.each(pageNavItemLinks, function () {

                    var value = $(this).attr('href');

                    //Don't push to itemsHref if href is "#"
                    if (value !== "#") {
                        itemsHref.push(value);
                    }
                });

                //populate #menu-toggler with the first menu item
                var firstNavItem = $(pageNavItemLinks[0]).find('.item-text').html();
                $('#menu-toggler').html(firstNavItem);

                //On scroll populate #menu-toggler with the last active menu item
                $(window).on('scroll', function () {

                    var isFirstElementSelected = false;

                    $.each(itemsHref, function (index, value) {
                        var element = $(value)[0];

                        if (element) {

                            if (isAnyPartOfElementInViewport(element)) {

                                if (!isFirstElementSelected) {

                                    var activeElement = $(".page-navigation .page-navigation-item").has("a[href='" + value + "']");

                                    //var activeElementTitle = activeElement[0].innerText.trim();

                                    var activeElementTitle = $(activeElement[0]).find("span.scWebEditInput").text();   // this will work okay in Exp. Editor
                                    if (!(activeElementTitle && activeElementTitle.length)) {
                                        // this will work in normal runtime
                                        activeElementTitle = $(activeElement[0]).find('.item-text').html();
                                    }

                                    $('#menu-toggler').html(activeElementTitle);

                                    isFirstElementSelected = true;

                                }

                            }

                        }

                    });

                });

                //Trigger mobile dropdown
                $('#menu-toggler').on('click', function () {

                    //Add .is-open to rotate the arrow
                    if (!$(this).hasClass('is-open')) {
                        $(this).addClass('is-open');
                    } else {
                        $(this).removeClass('is-open');
                    }

                    //Display all available menu items
                    $.each(pageNavItems, function () {

                        if ($(this).hasClass('active')) {
                            $(this).removeClass('active');
                        } else {
                            $(this).addClass('active');
                        }

                    });

                });

                //After selecting a menu item pass it's text into #toggler and hide other items
                $.each(pageNavItems, function (index) {
                    $(this).on('click', function (event) {

                        event.preventDefault();

                        $('#menu-toggler').html($(this).find('.item-text').html());
                        $('#menu-toggler').removeClass('is-open');
                        $(pageNavItems).removeClass('active');

                        //Add scroll offset
                        var $target = $(itemsHref);
                        var menuToggler = document.getElementById('menu-toggler');
                        var menuTogglerHeight = menuToggler.offsetHeight;

                        $("html, body").animate({ scrollTop: $(itemsHref[index]).offset().top - menuTogglerHeight }, 500);
                        //$("html, body").animate({ scrollTop: $(itemsHref[index]).offset().top - menuTogglerHeight + 64  }, 500);

                    });
                });
            });

            //DESKTOP PAGE NAVIGATION

            // Initialize all Page Navigation components on the page
            $(pageNavigationSelector).each(function (i, element) {

                var activeCssClasses = $(element).data("activeItemClasses");
                var pageNavItems = $(".page-navigation .page-navigation-item a[href^='#']");
                var itemsHref = [];

                //Extract ids from pageNavItems
                $.each(pageNavItems, function () { 

                    var value = $(this).attr('href');

                    //Don't push to itemsHref if href is "#"
                    if (value !== "#") {
                        itemsHref.push(value);
                    }
                });


                //On scroll highlight active menu items
                $(window).on('scroll', function () {

                    var isFirstElementSelected = false;
                    
                    $.each(itemsHref, function (index, value) {
                        var element = $(value)[0];

                        if (element) {

                            if (isAnyPartOfElementInViewport(element)) {

                                if (!isFirstElementSelected) {
                                    deselectAllHrefs(itemsHref, activeCssClasses);
                                    var activeElement = $(".page-navigation .page-navigation-item").has("a[href='" + value + "']");
                                    if (activeElement)
                                        $(activeElement).addClass(activeCssClasses);

                                    isFirstElementSelected = true;
                                }

                            }
                            else {
                                var activeElement = $(".page-navigation .page-navigation-item").has("a[href='" + value + "']");
                                if(activeElement)
                                $(activeElement).removeClass(activeCssClasses);
                            }

                        }

                    });

                });


            });

        }

        return {
            init: init
        };
    }
);

